/* Apparition douce des blocs au défilement (voir fruch-motion.css).
   Ne fait rien dans l'éditeur de thème, ni si le visiteur a demandé « réduire les animations ».
   Simple écoute du défilement (en capture : la page défile dans .page-wrapper, pas dans la fenêtre) :
   quelques blocs seulement, donc une mesure par bloc suffit. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var pending = [];

  function check() {
    var limit = window.innerHeight * 0.92;
    pending = pending.filter(function (block) {
      if (block.getBoundingClientRect().top > limit) return true;
      block.classList.add('is-in');
      return false;
    });
    if (!pending.length) {
      document.removeEventListener('scroll', check, true);
      window.removeEventListener('resize', check);
    }
  }

  function init() {
    var blocks = document.querySelectorAll('#MainContent > .shopify-section:not(:first-child)');
    var limit = window.innerHeight * 0.92;
    blocks.forEach(function (block) {
      /* Les blocs déjà visibles au chargement restent tels quels. */
      if (block.getBoundingClientRect().top <= limit) return;
      block.classList.add('fruch-reveal');
      pending.push(block);
    });
    if (!pending.length) return;
    document.addEventListener('scroll', check, { capture: true, passive: true });
    window.addEventListener('resize', check);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
